export const DOWNLOADING_PROFILE = 'DOWNLOADING_PROFILE'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_SUPPORTERS = 'SET_SUPPORTERS'
export const SET_PORTFOLIO = 'SET_PORTFOLIO'
export const RESET_STATE = 'RESET_STATE'